import { Component, HostListener, input, output } from '@angular/core';
import { QuestionarioFormValue } from '../../core/models/questionario-form.model';
import { QuestionarioConteudoComponent } from './questionario-conteudo.component';

@Component({
  selector: 'app-visualizar-questionario-modal',
  standalone: true,
  imports: [QuestionarioConteudoComponent],
  templateUrl: './visualizar-questionario-modal.component.html',
  styleUrl: './visualizar-questionario-modal.component.scss',
})
export class VisualizarQuestionarioModalComponent {
  readonly questionario = input.required<QuestionarioFormValue>();

  readonly fechar = output<void>();

  onFechar(): void {
    this.fechar.emit();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.onFechar();
  }
}
